/**
 * Underline-style tab navigation — Minimal Épuré.
 */
const TabNav = ({ tabs, activeTab, onTabChange }) => (
  <div className="flex gap-8 border-b border-stone-200 overflow-x-auto no-scrollbar">
    {tabs.map(({ key, label }) => (
      <button
        key={key}
        onClick={() => onTabChange(key)}
        className={`tab-ul shrink-0 ${activeTab === key ? 'tab-ul-active' : 'tab-ul-inactive'}`}
      >
        {label}
      </button>
    ))}
  </div>
);

export default TabNav;
